module.exports = __webpack_public_path__ + "static/media/beachbackground.d7496b6e.png";